"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductSensitivity_1 = require("../model/ProductSensitivity");

var ProductSensitivityConverter_1 = require("./ProductSensitivityConverter");
/**
 * Default implementation of ProductSensitivityConverter.
 *
 * @author JMe
 */


var ProductSensitivityConverterImpl =
/*#__PURE__*/
function (_ProductSensitivityCo) {
  _inherits(ProductSensitivityConverterImpl, _ProductSensitivityCo);

  function ProductSensitivityConverterImpl() {
    _classCallCheck(this, ProductSensitivityConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityConverterImpl).apply(this, arguments));
  }

  _createClass(ProductSensitivityConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductSensitivity_1.ProductSensitivity(conversions.documentToClassId(source), source.externalId, source.title, source.isDefault);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        title: source.title,
        isDefault: source.isDefault
      });
      return result;
    }
  }]);

  return ProductSensitivityConverterImpl;
}(ProductSensitivityConverter_1.ProductSensitivityConverter);

exports.ProductSensitivityConverterImpl = ProductSensitivityConverterImpl;